import { Box, Link, Stack } from "@mui/material"
import { Divider, formatNumber, GenericWrapperContext, LinearProgress, LoadingContainer, TAccountReport, Typography } from "@cakemail-org/ui-components-v2"
import { useContext, useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import "./styles.scss"
import { NavLink } from "react-router-dom"

export function EmailAPIBillingBlock() {
    const genericWrapper = useContext(GenericWrapperContext)
    const { t, i18n } = useTranslation()

    const [billingPlan, setBillingPlan] = useState()
    const [accountReport, setAccountReport] = useState<TAccountReport>()

    const freeCalls = 35000

    useEffect(fetchBillingInfo, [])
    useEffect(fetchAccountReportInfo, [])

    function fetchBillingInfo() {

    }

    function fetchAccountReportInfo() {
        genericWrapper.account?.getReport({}).then((data) => {
            //debugger
            setAccountReport(data)
        }).catch(() => {
            //debugger
        })
    }

    function getOverageFee() {
        const apiCalls = accountReport?.email_api?.submitted || 0
        const unitSize = 1000
        const costPerUnit = 1
        if (apiCalls <= freeCalls) {
            return 0
        }

        const overageUnits = (apiCalls - freeCalls) / unitSize
        return formatNumber(overageUnits * costPerUnit)

    }

    return <Stack className="emailAPIBillingBlock" gap={4}>
        <LoadingContainer loading={!accountReport}>
            {accountReport && <>
                <Stack direction="row" justifyContent="space-between" alignItems="center">
                    <Typography variant="titleS">API {/*formatNumber(freeCalls)*/}</Typography>

                    {/* <NavLink to={"https://www.cakemail.com/plans/email-api"}><Typography variant="link" color="body1.main">{t("general-manage-plan-txt")}</Typography></NavLink>*/}
                </Stack>
                <Stack gap={2}>
                    <Stack direction="row" justifyContent="space-between" alignItems="center">
                        <Typography className="semiBold">{t("email-api-billing-submitted")}</Typography>
                        <Typography>{accountReport.email_api?.submitted}</Typography>
                        {/*<Typography>{accountReport.email_api.submitted} / {formatNumber(freeCalls)}</Typography>*/}
                    </Stack>
                    {/* <Stack direction="row" justifyContent="space-between" alignItems="center">
                        <Typography className="semiBold">{t("general-overage-fees")}</Typography>
                        <Typography>${getOverageFee()}</Typography>
                    </Stack>*/}
                </Stack>
                {/*<Divider />
                <Stack gap={3}>
                    <Stack direction="row" justifyContent="space-between" alignItems="center">
                        <Typography className="semiBold">{t("general-reputation")}</Typography>
                        <Typography>99%</Typography>
                    </Stack>
                    <LinearProgress variant="determinate" value={99} color="secondary" />
                </Stack>*/}
            </>}

        </LoadingContainer>
    </Stack >
}